export interface Expense {
  id: string;
  expenseNumber: string;
  date: string;
  amount: number;
  expenseAccountId: string;
  paymentAccountId: string;
  vendorId?: string;
  bankAccountId?: string;
  payeeName?: string;
  paymentMethod: string;
  reference?: string;
  notes?: string;
  status: ExpenseStatus;
  companyId: string;
  createdAt: string;
  updatedAt: string;
  vendor?: {
    id: string;
    name: string;
    email?: string;
  };
  expenseAccount?: {
    id: string;
    code: string;
    name: string;
  };
  paymentAccount?: {
    id: string;
    code: string;
    name: string;
  };
  bankAccount?: {
    id: string;
    accountName: string;
    bankName: string;
  };
}

export type ExpenseStatus = 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export interface CreateExpenseData {
  amount: number;
  date?: string;
  expenseAccountId: string;
  bankAccountId: string;
  vendorId?: string;
  payeeName?: string;
  paymentMethod?: string;
  reference?: string;
  notes?: string;
}

export interface UpdateExpenseData {
  reference?: string;
  notes?: string;
  status?: ExpenseStatus;
}

export interface ExpenseFilters {
  page?: number;
  limit?: number;
  vendorId?: string;
  status?: ExpenseStatus;
  search?: string;
}

export interface ExpensesResponse {
  expenses: Expense[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export const EXPENSE_PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'debit_card', label: 'Debit Card' },
  { value: 'check', label: 'Check' },
  { value: 'other', label: 'Other' },
] as const;

export const EXPENSE_STATUS_LABELS: Record<ExpenseStatus, string> = {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
};
